// src/App.tsx
import { useState } from 'react'
import { EmailCapture } from './components/quiz/EmailCapture'
import { QuizFlow } from './components/quiz/QuizFlow'

type AppPhase = 'capture' | 'quiz'

export function App() {
  const [phase, setPhase] = useState<AppPhase>(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      if (params.get('session')) return 'quiz'

      const saved = localStorage.getItem('femm_quiz_state')
      if (saved) return 'quiz'
    }
    return 'capture'
  })
  const [email, setEmail] = useState('')
  const [firstName, setFirstName] = useState('')

  const handleEmailSubmit = (submittedEmail: string, submittedName: string) => {
    setEmail(submittedEmail)
    setFirstName(submittedName)
    setPhase('quiz')
  }

  if (phase === 'capture') {
    return <EmailCapture onSubmit={handleEmailSubmit} />
  }

  return <QuizFlow email={email} firstName={firstName} />
}
